const sites = [
  {
    id: 1,
    name: 'AutoDS',
    domain: 'autods.com',
    category: '对手',
    icon: 'https://www.autods.com/favicon.ico',
    crawlConfig: '{}',
    isActive: 1,
    createdAt: new Date().toISOString()
  }
]
const articles = []
const analyses = {}
const rewrites = {}
const tasks = {}
const blogMonitors = [
  {
    id: 1,
    sourceSiteId: 1,
    sourceSiteName: 'AutoDS',
    name: 'AutoDS Popular Articles',
    listUrl: 'https://www.autods.com/blog/popular-articles/',
    articleLinkSelector: 'article a[href], .post a[href], .entry-title a[href], h2 a[href], h3 a[href], a[href]',
    intervalHours: 4,
    maxLinks: 30,
    enabled: 1,
    autoAnalyze: 0,
    autoRewrite: 0,
    lastStatus: 'PENDING',
    lastFoundCount: 0,
    lastNewCount: 0,
    nextCheckAt: new Date().toISOString()
  }
]
const publishTemplates = [
  {
    id: 1,
    name: '经典博客',
    templateKey: 'classic',
    description: '通用博客排版，适合 SEO 内容、教程和新闻型文章。',
    htmlTemplate: '<article class="blog-preview"><header class="blog-header"><div class="eyebrow">{{tags}}</div><h1>{{title}}</h1><p class="lead">{{summary}}</p>{{coverImage}}</header><main class="content">{{content}}</main></article>',
    css: 'body{margin:0;background:#fff;color:#1f2937;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Microsoft YaHei",Arial,sans-serif}*,*::before,*::after{box-sizing:border-box}.blog-preview{max-width:900px;margin:0 auto;padding:34px 34px 56px}.blog-header{margin-bottom:28px;padding-bottom:22px;border-bottom:1px solid #e5e7eb}.eyebrow{color:#2563eb;font-size:13px;font-weight:700;margin-bottom:12px}.blog-header h1{margin:0 0 14px;color:#111827;font-size:34px;line-height:1.25;font-weight:760;letter-spacing:0}.lead{margin:0 0 14px;color:#4b5563;font-size:17px;line-height:1.8}.cover{display:block;width:100%;max-height:480px;object-fit:cover;margin-top:20px;border-radius:6px}.content{font-size:16px;line-height:1.85}.content h2{font-size:24px;margin:30px 0 14px;padding-left:12px;border-left:4px solid #2563eb}.content img{display:block;max-width:100%;height:auto;margin:20px auto;border-radius:6px}',
    theme: 'blue',
    isDefault: 1,
    enabled: 1
  },
  {
    id: 2,
    name: '杂志封面',
    templateKey: 'magazine',
    description: '强视觉封面风格，适合品牌稿、行业观察和深度文章。',
    htmlTemplate: '<article class="blog-preview"><header class="blog-header"><div class="eyebrow">{{tags}}</div><h1>{{title}}</h1><p class="lead">{{summary}}</p>{{coverImage}}</header><main class="content">{{content}}</main></article>',
    css: 'body{margin:0;background:#f3f0ea;color:#111827;font-family:Georgia,"Times New Roman","PingFang SC","Microsoft YaHei",serif}*,*::before,*::after{box-sizing:border-box}.blog-preview{max-width:980px;margin:0 auto 54px;background:#fff}.blog-header{padding:54px 64px 34px;margin:0 0 30px;background:#111827;color:#fff}.eyebrow{color:#fbbf24;font-size:13px;font-weight:700;margin-bottom:14px}.blog-header h1{margin:0 0 18px;color:#fff;font-size:44px;line-height:1.18;font-weight:760;letter-spacing:0;max-width:820px}.lead{color:#d1d5db;max-width:760px;font-size:18px;line-height:1.85}.cover{display:block;object-fit:cover;max-height:540px;margin:28px -64px -34px;width:calc(100% + 128px)}.content{padding:0 64px 60px;font-size:17px;line-height:1.9}.content h2{border-left:0;padding-left:0;font-size:28px;border-bottom:2px solid #111827;padding-bottom:8px;margin-top:34px}.content img{display:block;max-width:100%;height:auto;margin:24px auto}',
    theme: 'dark',
    isDefault: 0,
    enabled: 1
  },
  {
    id: 3,
    name: 'AutoDS风格博客',
    templateKey: 'autods-blog',
    description: '参考 AutoDS 博客统一排版：hero图区、作者信息、侧边目录、正文卡片、蓝色标题层级和营销 CTA。',
    htmlTemplate: '<div class="autods-progress"><span></span></div><article class="autods-blog"><section class="post-hero"><div class="container-full"><nav class="breadcrumb"><span>Dropshipping Blog</span><span class="separator">/</span><span>{{tags}}</span></nav><div class="hero-grid"><div class="hero-info"><h1>{{title}}</h1><p class="excerpt">{{summary}}</p><div class="author-row"><div class="author-avatar">AI</div><div><div class="author-name"><span>by</span> Blog Editorial Team</div><div class="post-meta">Updated for SEO · 8 minutes read</div></div></div></div><div class="post-thumbnail">{{coverImage}}</div></div></div></section><section class="post-content-wrapper"><div class="container-full post-layout"><aside class="post-nav"><div class="title">post content</div><div class="links"><a href="#overview">Overview</a><a href="#key-takeaways">Key takeaways</a><a href="#guide">Guide</a><a href="#faq">FAQ</a></div></aside><main class="post-content">{{content}}</main></div></section></article>',
    css: 'body{margin:0;background:#fff;color:#0f172a;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Microsoft YaHei",Arial,sans-serif}*,*::before,*::after{box-sizing:border-box}.autods-progress{position:sticky;top:0;z-index:20;height:5px;background:#e8f0ff}.autods-progress span{display:block;width:38%;height:100%;background:linear-gradient(90deg,#1a73ff,#47b6ff);border-radius:0 999px 999px 0}.container-full{width:min(1180px,calc(100% - 48px));margin:0 auto}.post-hero{background:linear-gradient(180deg,#f4f8ff 0%,#fff 100%);padding:34px 0 42px;border-bottom:1px solid #e5eefc}.breadcrumb{display:flex;gap:10px;margin-bottom:26px;color:#516070;font-size:14px;font-weight:600}.breadcrumb span:last-child{color:#1b73f8}.hero-grid{display:grid;grid-template-columns:minmax(0,1.02fr) minmax(360px,.98fr);gap:44px;align-items:center}.hero-info h1{margin:0 0 18px;color:#111827;font-size:48px;line-height:1.12;font-weight:800;letter-spacing:0}.excerpt{max-width:640px;margin:0 0 24px;color:#4b6078;font-size:18px;line-height:1.75}.author-row{display:inline-flex;align-items:center;gap:13px;padding:10px 16px 10px 10px;background:#fff;border:1px solid #e4edfb;border-radius:999px;box-shadow:0 12px 30px rgba(15,64,135,.08)}.author-avatar{width:44px;height:44px;border-radius:50%;background:linear-gradient(135deg,#1a73ff,#18c2ff);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:14px}.author-name{color:#111827;font-size:14px;font-weight:750}.author-name span{color:#728199;font-weight:600;margin-right:4px}.post-meta{margin-top:2px;color:#728199;font-size:13px}.post-thumbnail{min-height:280px;border-radius:28px;overflow:hidden;background:#eaf2ff;box-shadow:0 24px 60px rgba(28,97,179,.18)}.post-thumbnail img,.post-thumbnail .cover{display:block;width:100%;height:100%;min-height:280px;max-height:470px;object-fit:cover;border-radius:28px;margin:0}.post-content-wrapper{padding:44px 0 76px}.post-layout{display:grid;grid-template-columns:260px minmax(0,820px);gap:42px;align-items:start}.post-nav{position:sticky;top:28px;padding:22px 20px;background:#fff;border:1px solid #e5edf8;border-radius:18px;box-shadow:0 16px 42px rgba(15,64,135,.08)}.post-nav .title{margin-bottom:14px;color:#0f172a;font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:.08em}.post-nav .links{display:flex;flex-direction:column;gap:9px}.post-nav a{color:#53657d;text-decoration:none;font-size:14px;line-height:1.45;padding:8px 10px;border-radius:10px}.post-content{min-width:0;color:#25364d;font-size:17px;line-height:1.86}.post-content h2{font-size:30px;margin:42px 0 16px;font-weight:800}.post-content h2::before{content:"";display:block;width:54px;height:5px;margin-bottom:13px;border-radius:999px;background:linear-gradient(90deg,#1a73ff,#18c2ff)}.post-content h3{font-size:22px;margin:30px 0 12px}.post-content img{display:block;width:auto;max-width:100%;height:auto;margin:24px auto;border-radius:20px;box-shadow:0 18px 46px rgba(15,64,135,.12)}.summary-box-shortcode,.key-takeaways,.takeaways{margin:28px 0;padding:26px;border-radius:22px;background:linear-gradient(180deg,#eef6ff 0%,#fff 100%);border:1px solid #d8e9ff;box-shadow:0 18px 48px rgba(28,97,179,.10)}@media(max-width:980px){.hero-grid{grid-template-columns:1fr}.post-layout{grid-template-columns:1fr}.hero-info h1{font-size:38px}}@media(max-width:640px){.container-full{width:min(100% - 28px,1180px)}.hero-info h1{font-size:30px}.post-nav{display:none}.post-content{font-size:16px}.post-content h2{font-size:24px}}',
    theme: 'autods-blue',
    isDefault: 0,
    enabled: 1
  }
]

let nextArticleId = 1
let nextSiteId = 2
let nextRewriteId = 1
let nextPublishTemplateId = 4
let nextBlogMonitorId = 2

let databaseConfig = {
  driverClassName: 'com.mysql.cj.jdbc.Driver',
  host: 'localhost',
  port: 3306,
  databaseName: 'blog_ai',
  username: 'root',
  password: 'root',
  params: 'useUnicode=true&characterEncoding=utf8&serverTimezone=Asia/Shanghai&useSSL=false'
}

let ossConfig = {
  endpoint: 'https://oss-cn-hangzhou.aliyuncs.com',
  publicEndpoint: '',
  bucketName: '',
  accessKeyId: '',
  accessKeySecret: '',
  basePath: 'blog-ai/',
  maxImageSizeMb: 20,
  maxVideoSizeMb: 200
}

function createTask(type, bizId) {
  const taskNo = `${type.toLowerCase()}-${Date.now()}`
  tasks[taskNo] = {
    taskNo,
    taskType: type,
    bizId,
    status: 'SUCCESS',
    progress: 100,
    createdAt: new Date().toISOString()
  }
  return taskNo
}

function paginate(records, params = {}) {
  const current = Number(params.page || 1)
  const size = Number(params.size || 10)
  const start = (current - 1) * size
  return {
    records: records.slice(start, start + size),
    total: records.length,
    size,
    current
  }
}

function databaseConfigView() {
  return {
    driverClassName: databaseConfig.driverClassName,
    host: databaseConfig.host,
    port: databaseConfig.port,
    databaseName: databaseConfig.databaseName,
    username: databaseConfig.username,
    params: databaseConfig.params,
    jdbcUrl: `jdbc:mysql://${databaseConfig.host}:${databaseConfig.port}/${databaseConfig.databaseName}?${databaseConfig.params}`,
    passwordConfigured: Boolean(databaseConfig.password)
  }
}

function ossConfigView() {
  return {
    endpoint: ossConfig.endpoint,
    publicEndpoint: ossConfig.publicEndpoint,
    bucketName: ossConfig.bucketName,
    accessKeyId: ossConfig.accessKeyId,
    basePath: ossConfig.basePath,
    maxImageSizeMb: ossConfig.maxImageSizeMb,
    maxVideoSizeMb: ossConfig.maxVideoSizeMb,
    accessKeySecretConfigured: Boolean(ossConfig.accessKeySecret)
  }
}

export function isBackendUnavailable(error) {
  const responseText = typeof error?.response?.data === 'string'
    ? error.response.data
    : error?.response?.data?.message || ''
  return (
    (error?.response?.status === 500 && String(responseText).includes('Proxy error')) ||
    error?.code === 'ECONNABORTED' ||
    !error?.response
  )
}

export const mockApi = {
  login(data) {
    const isAdmin = data.username === 'fulfillagent' && data.password === 'fulfillagent@2026'
    const isLegacyLocalAdmin = data.username === 'admin' && data.password === 'admin123'
    if (isAdmin || isLegacyLocalAdmin) {
      return {
        token: 'dev-local-token',
        username: 'fulfillagent',
        nickname: '系统管理员',
        role: 'admin'
      }
    }
    throw new Error('用户名或密码错误')
  },
  submitCrawl(data) {
    const site = sites.find(item => item.id === Number(data.sourceSiteId))
    const article = {
      id: nextArticleId++,
      sourceSiteId: data.sourceSiteId || null,
      sourceSiteName: site?.name || '',
      originalUrl: data.url,
      title: `测试收录文章 ${nextArticleId - 1}`,
      author: 'Mock Author',
      originalPublishTime: new Date(Date.now() - 86400000).toISOString(),
      similarityRiskLevel: '',
      similarityScore: null,
      similarityMarked: 0,
      similarityCheckedAt: null,
      status: 'CRAWLED',
      plainText: '这是一篇用于前端联调的模拟博客正文。启动 Spring Boot 后，系统会从真实 URL 抓取标题、正文、作者、封面图并写入 MySQL。',
      content: '<p>这是一篇用于前端联调的模拟博客正文。</p>',
      createdAt: new Date().toISOString()
    }
    articles.unshift(article)
    return { taskNo: createTask('CRAWL', article.id) }
  },
  getBlogMonitors(params = {}) {
    return params.sourceSiteId
      ? blogMonitors.filter(item => item.sourceSiteId === Number(params.sourceSiteId))
      : blogMonitors
  },
  createBlogMonitor(data) {
    const site = sites.find(item => item.id === Number(data.sourceSiteId))
    const item = {
      ...data,
      id: nextBlogMonitorId++,
      sourceSiteName: site?.name || '',
      autoAnalyze: data.autoAnalyze || 0,
      autoRewrite: data.autoRewrite || 0,
      lastStatus: 'PENDING',
      lastFoundCount: 0,
      lastNewCount: 0,
      nextCheckAt: new Date().toISOString()
    }
    blogMonitors.unshift(item)
    return item
  },
  updateBlogMonitor(id, data) {
    const item = blogMonitors.find(row => row.id === Number(id))
    if (item) {
      const site = sites.find(row => row.id === Number(data.sourceSiteId || item.sourceSiteId))
      Object.assign(item, data, { sourceSiteName: site?.name || item.sourceSiteName || '' })
    }
    return item || data
  },
  deleteBlogMonitor(id) {
    const index = blogMonitors.findIndex(row => row.id === Number(id))
    if (index >= 0) blogMonitors.splice(index, 1)
    return true
  },
  checkBlogMonitor(id) {
    const item = blogMonitors.find(row => row.id === Number(id))
    if (item) {
      item.lastStatus = 'SUCCESS'
      item.lastFoundCount = 8
      item.lastNewCount = 1
      item.lastCheckedAt = new Date().toISOString()
      item.nextCheckAt = new Date(Date.now() + Number(item.intervalHours || 4) * 3600000).toISOString()
    }
    return { taskNo: createTask('BLOG_MONITOR_CHECK', Number(id)) }
  },
  checkAllBlogMonitors() {
    blogMonitors.forEach(item => {
      item.lastStatus = 'SUCCESS'
      item.lastFoundCount = Math.max(item.lastFoundCount || 0, 8)
      item.lastNewCount = 0
      item.lastCheckedAt = new Date().toISOString()
      item.nextCheckAt = new Date(Date.now() + Number(item.intervalHours || 4) * 3600000).toISOString()
    })
    return { taskNo: createTask('BLOG_MONITOR_CHECK_ALL', 0) }
  },
  backfillPublishTimes() {
    articles.forEach(item => {
      if (!item.originalPublishTime) {
        item.originalPublishTime = item.createdAt || new Date().toISOString()
      }
    })
    return { taskNo: createTask('BACKFILL_PUBLISH_TIME', 0) }
  },
  getTask(taskNo) {
    return tasks[taskNo] || null
  },
  getArticles(params = {}) {
    const keyword = params.keyword || ''
    const status = params.status || ''
    const source = params.source || ''
    const selectedSourceIds = String(params.sourceSiteIds || '')
      .split(',')
      .map(value => Number(value))
      .filter(value => Number.isFinite(value) && value > 0)
    const selectedRiskLevels = String(params.similarityRiskLevels || '')
      .split(',')
      .map(value => value.trim())
      .filter(Boolean)
    const filtered = articles.filter(item => {
      const level = item.similarityRiskLevel || ''
      const riskMatched = !selectedRiskLevels.length ||
        selectedRiskLevels.includes(level) ||
        (selectedRiskLevels.includes('UNCHECKED') && !level)
      return (!keyword || String(item.title || '').includes(keyword)) &&
        (!status || item.status === status) &&
        (!selectedSourceIds.length || selectedSourceIds.includes(Number(item.sourceSiteId))) &&
        riskMatched &&
        (!source || String(item.originalUrl || '').includes(source) || String(item.sourceSiteName || '').includes(source))
    })
    return paginate(filtered, params)
  },
  getArticleSourceOptions() {
    return sites
      .map(site => {
        const count = articles.filter(item => Number(item.sourceSiteId) === Number(site.id)).length
        return {
          sourceSiteId: site.id,
          name: site.name,
          domain: site.domain,
          articleCount: count
        }
      })
      .filter(item => item.articleCount > 0)
      .sort((left, right) => right.articleCount - left.articleCount || String(left.name).localeCompare(String(right.name)))
  },
  getArticle(id) {
    return articles.find(item => item.id === Number(id)) || null
  },
  createAnalysis(id) {
    const articleId = Number(id)
    analyses[articleId] = {
      articleId,
      keywords: '["博客","AI","内容优化"]',
      summary: '这是一条模拟 AI 分析摘要，用于前端流程测试。',
      sentiment: 'neutral',
      analysisStatus: 'completed',
      readabilityScore: 78,
      wordCount: 86,
      category: '内容营销',
      strengths: '- 标题和主题明确\n- 正文结构适合后续改写',
      weaknesses: '- 内容深度不足\n- SEO关键词布局较弱',
      optimizationSuggestions: '- 增加小标题和 FAQ\n- 补充更明确的 SEO 标题与描述',
      createdAt: new Date().toISOString()
    }
    const article = articles.find(item => item.id === articleId)
    if (article) {
      article.status = 'ANALYZED'
      article.similarityRiskLevel = 'LOW'
      article.similarityScore = 0
      article.similarityMarked = 0
      article.similarityCheckedAt = new Date().toISOString()
    }
    return { taskNo: createTask('ANALYSIS', articleId) }
  },
  getAnalysis(id) {
    return analyses[Number(id)] || null
  },
  getArticleSimilarities() {
    return []
  },
  recheckArticleSimilarity(id) {
    const article = articles.find(item => item.id === Number(id))
    if (article) {
      article.similarityRiskLevel = 'CHECKING'
      article.similarityScore = 0
      article.similarityMarked = 0
      article.similarityCheckedAt = new Date().toISOString()
      setTimeout(() => {
        article.similarityRiskLevel = 'LOW'
        article.similarityScore = 0
        article.similarityMarked = 0
        article.similarityCheckedAt = new Date().toISOString()
      }, 1000)
    }
    return true
  },
  createRewrite(id) {
    const articleId = Number(id)
    const rewrite = {
      id: nextRewriteId++,
      articleId,
      title: 'Optimized Test Blog Article',
      summary: 'A simulated English rewrite summary.',
      content: '<h2>Optimized Test Blog Article</h2><p>This is a simulated English blog draft generated for preview, editing, and publishing tests.</p>',
      seoTitle: 'Optimized Test Blog Article',
      seoDescription: 'A simulated SEO description for testing the publishing preview.',
      tags: '["Blog","AI","Optimization"]',
      status: 'completed'
    }
    rewrites[articleId] = rewrites[articleId] || []
    rewrites[articleId].unshift(rewrite)
    const article = articles.find(item => item.id === articleId)
    if (article) article.status = 'REWRITTEN'
    return { taskNo: createTask('REWRITE', articleId) }
  },
  batchRewriteArticles(ids = []) {
    const taskNos = ids.map(id => this.createRewrite(id, {}).taskNo)
    return {
      submitted: taskNos.length,
      taskNos
    }
  },
  createManualRewrite(id, data) {
    const articleId = Number(id)
    const rewrite = {
      ...data,
      id: nextRewriteId++,
      articleId,
      status: data.status || 'manual'
    }
    rewrites[articleId] = rewrites[articleId] || []
    rewrites[articleId].unshift(rewrite)
    return rewrite
  },
  getRewrites(id) {
    return rewrites[Number(id)] || []
  },
  updateRewrite(id, data) {
    const item = Object.values(rewrites).flat().find(row => row.id === Number(id))
    if (item) Object.assign(item, data)
    return item || data
  },
  deleteRewrite(id) {
    Object.keys(rewrites).forEach(articleId => {
      const index = rewrites[articleId].findIndex(row => row.id === Number(id))
      if (index >= 0) rewrites[articleId].splice(index, 1)
    })
    return true
  },
  publishRewrite(id, data) {
    return {
      id: Date.now(),
      rewriteId: Number(id),
      platform: data.platform || '自有博客',
      status: 'published',
      publishTemplate: data.publishTemplate,
      publishHtml: data.publishHtml,
      publishedAt: new Date().toISOString()
    }
  },
  getPublishTemplates() {
    return publishTemplates.filter(item => item.enabled === 1)
  },
  getAllPublishTemplates() {
    return publishTemplates
  },
  createPublishTemplate(data) {
    const item = { ...data, id: nextPublishTemplateId++ }
    publishTemplates.unshift(item)
    return item
  },
  updatePublishTemplate(id, data) {
    const item = publishTemplates.find(row => row.id === Number(id))
    if (item) Object.assign(item, data)
    return item || data
  },
  deletePublishTemplate(id) {
    const index = publishTemplates.findIndex(row => row.id === Number(id))
    if (index >= 0) publishTemplates.splice(index, 1)
    return true
  },
  getSites(params = {}) {
    const filtered = params.category
      ? sites.filter(item => item.category === params.category)
      : sites
    return paginate(filtered, params)
  },
  getSiteCategoryOptions() {
    return ['对手', '选品', 'shopify运营', '物流', '收款', '中国采购'].map(category => ({
      category,
      siteCount: sites.filter(item => item.category === category).length
    }))
  },
  createSite(data) {
    const item = { ...data, id: nextSiteId++, createdAt: new Date().toISOString() }
    sites.unshift(item)
    return item
  },
  updateSite(id, data) {
    const item = sites.find(row => row.id === Number(id))
    if (item) Object.assign(item, data)
    return item || data
  },
  deleteSite(id) {
    const index = sites.findIndex(row => row.id === Number(id))
    if (index >= 0) sites.splice(index, 1)
    return true
  },
  getDatabaseConfig() {
    return databaseConfigView()
  },
  testDatabaseConfig(data) {
    if (!data.host || !data.port || !data.databaseName || !data.username) {
      throw new Error('请填写完整的数据库连接信息')
    }
    return true
  },
  saveDatabaseConfig(data) {
    databaseConfig = {
      ...databaseConfig,
      ...data,
      password: data.password || databaseConfig.password
    }
    return databaseConfigView()
  },
  getOssConfig() {
    return ossConfigView()
  },
  testOssConfig(data) {
    if (!data.endpoint || !data.bucketName || !data.accessKeyId) {
      throw new Error('请填写完整的OSS连接信息')
    }
    return true
  },
  saveOssConfig(data) {
    ossConfig = {
      ...ossConfig,
      ...data,
      accessKeySecret: data.accessKeySecret || ossConfig.accessKeySecret
    }
    return ossConfigView()
  },
  uploadAttachment(file, mediaType = 'image') {
    const ext = String(file?.name || '').split('.').pop() || (mediaType === 'video' ? 'mp4' : 'jpg')
    return {
      url: `https://example.com/mock/${mediaType}/${Date.now()}.${ext}`,
      objectKey: `mock/${mediaType}/${Date.now()}.${ext}`,
      fileName: file?.name || '',
      contentType: file?.type || '',
      size: file?.size || 0,
      mediaType
    }
  }
}
